import {
  DashboardChartMetadataErrorIdentifier,
  DashboardChartMetadataStatus,
} from './dashboard-chart-data-general.symbols';
import {DashboardChartDataPvsConfig} from './dashboard-chart-data-pvs.symbols';

/**
 * Defines the PVS score meanings for the chart.
 */
export enum DashboardChartDataPvsScore {
  /** No data. */
  None = 'none',

  /** Good result. User's volume is better than average. */
  Low = 'low',

  /** Good result. User's volume is average. */
  Typical = 'typical',

  /** Bad result. User's volume is worse than average. */
  Elevated = 'elevated',

  /** Bad result. User's volume is much worse than average. */
  High = 'high',
}

/**
 * Defines the PVS score group colors for the chart.
 */
export const DashboardChartDataPvsGroupColors = {
  [DashboardChartDataPvsScore.None]: '#2E4FD7',
  [DashboardChartDataPvsScore.Low]: '#2E4FD7',
  [DashboardChartDataPvsScore.Typical]: '#ABB9EF',
  [DashboardChartDataPvsScore.Elevated]: '#FF99A3',
  [DashboardChartDataPvsScore.High]: '#EC5564',
};

/**
 * Defines the PVS score group by its value.
 */
export const dashboardChartDataDefinePvsScoreGroup = (pvsScore: number): DashboardChartDataPvsScore => {
  if (pvsScore === null || pvsScore === undefined || pvsScore === 0) {
    return DashboardChartDataPvsScore.None;
  } else if (pvsScore < 2) {
    return DashboardChartDataPvsScore.Low;
  } else if (pvsScore < 3) {
    return DashboardChartDataPvsScore.Typical;
  } else if (pvsScore < 4) {
    return DashboardChartDataPvsScore.Elevated;
  } else {
    return DashboardChartDataPvsScore.High;
  }
};

/**
 * Default empty values for the chart config.
 */
const pvsChartDefaultConfigValues: DashboardChartDataPvsConfig = {
  dataPointsConfig: [],
  chartMetadata: {
    processStatus: DashboardChartMetadataStatus.ShouldBeHidden,
    errorIdentifier: null,
  },
};

/**
 * Defines the last error identifier for the chart.
 * Returns compatible chart config.
 */
export const pvsChartUtilsProvideErrorStatus = (
  errorIdentifier: DashboardChartMetadataErrorIdentifier
): DashboardChartDataPvsConfig => {
  return {
    ...pvsChartDefaultConfigValues,
    chartMetadata: {
      processStatus: DashboardChartMetadataStatus.Error,
      errorIdentifier,
    },
  };
};

/**
 * Provides the chart config with the hidden status.
 */
export const pvsChartUtilsProvideHiddenStatus = (): DashboardChartDataPvsConfig => {
  return {
    ...pvsChartDefaultConfigValues,
    chartMetadata: {
      processStatus: DashboardChartMetadataStatus.ShouldBeHidden,
      errorIdentifier: null,
    },
  };
};
